import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import React from 'react';
import { theme } from 'styles/theme/theme';

interface TemplateInfoProps {
  name: string | undefined;
  version: number | string | undefined;
  objectCount: number;
  zoom: number;
}

const TemplateInfo: React.FC<TemplateInfoProps> = ({ name, version, objectCount, zoom }) => (
  <Root>
    <Row>
      <Label>
        <Trans>Шаблон</Trans>
      </Label>
      <Value>{name ?? '—'}</Value>
    </Row>
    <Row>
      <Label>
        <Trans>Версия</Trans>
      </Label>
      <Value>{version ?? '—'}</Value>
    </Row>
    <Row>
      <Label>
        <Trans>Объекты</Trans>
      </Label>
      <Value>{objectCount}</Value>
    </Row>
    <Row>
      <Label>
        <Trans>Масштаб</Trans>
      </Label>
      <Value>{zoom.toFixed(2)}×</Value>
    </Row>
  </Root>
);

export default TemplateInfo;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
`;

const Label = styled.span`
  color: ${theme.colors.Gray};
`;

const Value = styled.span`
  color: ${theme.colors.DarkBlue600};
  font-weight: 500;
`;
